import axios from "axios";

const BASE_URL = `/m-1/calendar`;

/**
 * Serwis do komunikacji z API - endpoint /calendar
 */
export const CalendarService = {
  getFreeCalendarDates,
  getFreeCalendar,
  getFreeCalendarDate,
  getFreeExclusiveCalendar,
  getFreeExclusiveCalendarDate,
  bookingMeeting,
  getMeetingDate,
};

function getFreeCalendarDates(dateString, offerId) {
  return axios.get(`${BASE_URL}/events/free/${dateString}/${offerId}`);
}

function getFreeCalendar(serviceType) {
  return axios.get(`${BASE_URL}/events-meetings/free/${serviceType}`);
}

function getFreeCalendarDate(serviceType, dateString) {
  return axios.get(
    `${BASE_URL}/events-meetings/free/${serviceType}/${dateString}`
  );
}

function getFreeExclusiveCalendar(exclusiveServiceType) {
  return axios.get(
    `${BASE_URL}/events-meetings/exclusive/free/${exclusiveServiceType}`
  );
}

function getFreeExclusiveCalendarDate(exclusiveServiceType, dateString) {
  return axios.get(
    `${BASE_URL}/events-meetings/exclusive/free/${exclusiveServiceType}/${dateString}`
  );
}

function bookingMeeting(clientId, data) {
  return axios.post(`${BASE_URL}/events-meetings/${clientId}`, data);
}

function getMeetingDate(id) {
  return axios.get(`${BASE_URL}/events-meeting/${id}`);
}
